import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated, mustResetPassword } from '../auth/session';
import { isQaSeedNavEnabled } from '../config/qa-seed';
import { QaSeedPage } from '../pages/qa-seed/qa-seed-page';

export const Route = createFileRoute('/qa-seed')({
  beforeLoad: () => {
    if (!isQaSeedNavEnabled()) {
      throw redirect({ to: '/contests' });
    }
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
    if (mustResetPassword()) {
      throw redirect({ to: '/change-password' });
    }
  },
  component: QaSeedPage,
});
